import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import type { ValidationError } from '@oysterjs/core/graphql';
import { Button } from '@oysterjs/ui/button';
import React from 'react';
import { DIRECTORY_CONFLICT_MESSAGE, DIRECTORY_PATH } from './voice-transfer-directory-changes';

/** A concurrent edit can't be fixed in place, so the only way out is a reload. */
export const VoiceDirectoryConflictNotice = React.forwardRef<
  HTMLDivElement,
  { conflicts: ValidationError[] }
>(function VoiceDirectoryConflictNotice({ conflicts }, ref) {
  if (conflicts.length === 0) {
    return null;
  }
  // A conflict on the directory as a whole may involve none of the editor's own rows.
  const isDirectoryWide = conflicts.some(
    (conflict) => conflict.field.length === DIRECTORY_PATH.length
  );

  return (
    <div
      ref={ref}
      role="alert"
      className="rounded-lg border border-amber-300 bg-amber-50 p-4 dark:border-amber-500/40 dark:bg-amber-500/10"
    >
      <div className="flex gap-3">
        <ExclamationTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-amber-600 dark:text-amber-400" />
        <div className="flex-1">
          <p className="text-sm font-medium text-amber-900 dark:text-amber-200">
            Your changes were not saved
          </p>
          <p className="mt-1 text-sm text-amber-800 dark:text-amber-300">
            {isDirectoryWide ? (
              DIRECTORY_CONFLICT_MESSAGE
            ) : (
              <>
                Someone else changed the same transfer directory
                {conflicts.length === 1 ? ' row ' : ' rows '}
                while you were editing, so nothing was saved. Reload to see their changes, then make
                yours again.
              </>
            )}
          </p>
          <div className="mt-3">
            <Button color="amber" onClick={() => window.location.reload()}>
              Reload page
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
});
